"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagSuggestionResponse = exports.TagSuggestion = exports.TagSuggestionRequest = void 0;
const typebox_1 = require("@sinclair/typebox");
const enums_1 = require("../common/enums");
exports.TagSuggestionRequest = typebox_1.Type.Object({
    ticketID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    text: typebox_1.Type.Optional(typebox_1.Type.String({ minLength: 1 })),
    haulerID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    entityType: typebox_1.Type.Optional(typebox_1.Type.Union([enums_1.SourgumInternalTicketRelatedEntity, enums_1.WaysteInternalTicketRelatedEntity])),
});
exports.TagSuggestion = typebox_1.Type.Object({
    tagID: typebox_1.Type.String({ format: 'uuid' }),
    tagName: typebox_1.Type.String(),
    confidence: typebox_1.Type.Number({ minimum: 0, maximum: 1 }),
    reason: typebox_1.Type.Optional(typebox_1.Type.String()),
});
exports.TagSuggestionResponse = typebox_1.Type.Object({
    suggestions: typebox_1.Type.Array(exports.TagSuggestion),
});
//# sourceMappingURL=tag-suggestion.js.map